import { isDefined } from '@sgme/fp';
import clsx from 'clsx';
import { FormattedMessage, useIntl } from 'react-intl';

import {
  useForwardAccumulatorSelector,
  useForwardAccumulatorTileId,
} from '@/App/tiles/ForwardAccumulator/ProductProvider.tsx';
import {
  getForwardAccumulatorMarketData,
  selectForwardAccumulatorProperty,
} from '@/store/forwardAccumulator/selectors.ts';
import { useAppSelector } from '@/store/hooks.ts';
import { useCurrencyPrecision } from '@/utils/currencies/useCurrencyPrecision.ts';

const Forward = () => {
  const { formatNumber } = useIntl();
  const tileId = useForwardAccumulatorTileId();
  const currencyPair = useAppSelector((state) => selectForwardAccumulatorProperty(state, tileId, 'currencyPair'));

  const marketData = useForwardAccumulatorSelector((accumulator) => getForwardAccumulatorMarketData(accumulator));
  const isExpired = useForwardAccumulatorSelector((accumulator) => accumulator.properties.rfs.status === 'EXPIRED');

  const precision = useCurrencyPrecision(currencyPair);

  return (
    <div className={clsx('form-group form-group-sm d-flex my-1 no-gutters', { expired: isExpired })}>
      <div className="pe-1 col-form-label col-form-label-sm col-4 text-nowrap text-end" style={{ width: '30%' }}>
        <FormattedMessage id="accumulator.fields.forward" />
      </div>
      {isDefined(marketData?.forward) && (
        <span className="col-7 fs-6" data-e2e="forward">
          {marketData?.forward.bid &&
            formatNumber(marketData?.forward.bid, {
              maximumFractionDigits: precision + 1,
              minimumFractionDigits: precision + 1,
            })}
          /
          {marketData?.forward.ask &&
            formatNumber(marketData?.forward.ask, {
              maximumFractionDigits: precision + 1,
              minimumFractionDigits: precision + 1,
            })}
        </span>
      )}
    </div>
  );
};

export default Forward;
